import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useOutletContext } from "react-router-dom";
import parse from "html-react-parser";
import { handleApiCall } from "../apis";
import { endpoints } from "../utils/endpoints";
import { UI_CONSTANTS } from "../utils/constants";
import { useLanguage } from "../context/LanguageContext";
import { getLocalizedFieldValue } from "../utils/language";
import he from "he";

function TermsAndConditions() {
  const outletContext = useOutletContext?.();
  const setBannerData = outletContext?.setBannerData;
  const { language } = useLanguage();
  const [termsContent, setTermsContent] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchTerms = useCallback(async () => {
    setLoading(true);
    try {
      const response = await handleApiCall(
        "get",
        `${endpoints.getContent}?type=term_and_condition`
      );
      if (
        response?.data?.code === 200 ||
        response?.data?.code === "200" ||
        response?.data?.success === true
      ) {
        const data = response?.data?.data;
        let normalized = null;
        if (Array.isArray(data)) {
          normalized = data[0] || null;
        } else if (Array.isArray(data?.data)) {
          normalized = data.data[0] || null;
        } else {
          normalized = data || null;
        }
        setTermsContent(normalized);
      } else {
        setTermsContent(null);
      }
    } catch (error) {
      console.error("Error fetching terms content:", error);
      setTermsContent(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    setBannerData?.({ bannershow: false });
    fetchTerms();
  }, [setBannerData, fetchTerms]);

  const title = useMemo(() => {
    if (!termsContent) return null;
    const localized =
      getLocalizedFieldValue(termsContent, language, "title", {
        englishKeys: ["title_en", "title_english"],
        arabicKeys: ["title_ar", "title_arabic"],
      }) ||
      termsContent?.title ||
      null;
    return localized;
  }, [termsContent, language]);

  // const description = useMemo(() => {
  //   if (!termsContent) return "";

  //   const arabicDescription =
  //     termsContent?.description_ar || termsContent?.description_arabic;
  //   const englishDescription =
  //     termsContent?.description_en || termsContent?.description_english;

  //   const preferred =
  //     language === "AR"
  //       ? arabicDescription || englishDescription
  //       : englishDescription || arabicDescription;

  //   return he.decode(preferred || termsContent?.description || "");
  // }, [termsContent, language]);

const description = useMemo(() => {
  if (!termsContent) return "";

  const arabicDescription =
    termsContent?.description_ar || termsContent?.description_arabic;
  const englishDescription =
    termsContent?.description_en || termsContent?.description_english;

  const preferred =
    language === "AR"
      ? arabicDescription || englishDescription
      : englishDescription || arabicDescription;

  let decoded = he.decode(preferred || termsContent?.description || "");

  // 🔥 Convert broken CMS spacing into DraftJS-style spacing
  decoded = decoded
    // empty <p>, <h1>-<h6>
    .replace(/<(h[1-6]|p)>\s*<\/\1>/gi, "<div><br></div>")

    // double <br><br>
    .replace(/(<br\s*\/?>\s*){2,}/gi, "<div><br></div>")

    // orphan <br>
    .replace(/<br\s*\/?>/gi, "<div><br></div>");

  return decoded;
}, [termsContent, language]);



  const displayTitle = useMemo(() => {
    const arabicLabel = "الشروط والأحكام";
    const englishLabel = "Terms & Conditions";

    if (language === "AR") {
      if (!title) return arabicLabel;
      if (title.includes(arabicLabel)) return title;
      return `${arabicLabel}`;
    }

    return title || englishLabel;
  }, [title, language]);

  return (
    <div className="container max-w-8xl mx-auto px-4 py-8 md:py-12 lg:py-20 text-white">
      <div className="max-w-4xl">
        <h1 className="text-3xl md:text-[2.625rem] font-SaudiaBold mb-6">
          {displayTitle}
        </h1>
        {loading ? (
          <p className="text-white/80">
            {UI_CONSTANTS.BUTTON_LABELS.LOADING || "Loading..."}
          </p>
        ) : description ? (
          // parse(description)
          <div
            className="
              text-white/90 mb-10 text-lg font-SaudiaLight
              prose prose-invert max-w-none
              [&_p]:mb-4
              [&_p:empty]:h-4
              [&_p:empty]:block
              [&_br]:block
            "
          >
            {parse(description)}
          </div>
        ) : (
          <p className="text-white/80">
            {language === "AR"
              ? "لا توجد بيانات متاحة حالياً."
              : "No data available at the moment."}
          </p>
        )}
      </div>
    </div>
  );
}

export default TermsAndConditions;
